import React from "react";
import classNames from "classnames";
import { Heading, Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { UpgradeMembershipModalProps } from "../../UpgradeMembershipModal";
import styles from "./ProductHeading.module.scss";

export type ProductHeadingProps = {
  className?: string;
  subTitle?: string;
} & Pick<UpgradeMembershipModalProps, "productName" | "productPrice">;

const ProductHeading = ({
  className,
  productName,
  productPrice,
  subTitle,
}: ProductHeadingProps) => {
  return (
    <>
      {productName ? (
        <Heading type="h5" className={classNames(styles.subtitle, className)}>
          {productPrice ? `${productName} | ${productPrice}` : productName}
        </Heading>
      ) : null}
      {subTitle ? <Paragraph weight="book">{subTitle}</Paragraph> : null}
    </>
  );
};

export default ProductHeading;
